import Vue from 'vue'
import App from './App.vue'
import store from './store'

// 引入路由
import router from '@/router'

// 引入axios
import axios from 'axios'
Vue.prototype.$axios = axios //全局注册，使用方法为:this.$axios

// Vue.config.productionTip = false

import * as API from '@/api'

// 引入element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
Vue.use(MintUI)

import { Swipe, SwipeItem, Cell, Checklist, Loadmore } from 'mint-ui';
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Cell.name, Cell);
Vue.component(Checklist.name, Checklist);
Vue.component(Loadmore.name, Loadmore);

// 引入cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// 引入插件
// import { MessageBox } from 'mint-ui';

import WebsocketPlugin from './websocket'
Vue.use(WebsocketPlugin)

// import global from './global.js';
// Vue.prototype.global = global

router.beforeEach((to, from, next) => {
  // 获取当前域名和二级子域名判定
  const hostname = window.location.hostname;
  const domainParts = hostname.split('.');
  const isSubdomain = 
    domainParts.length > 2 && 
    domainParts[0] !== 'www' && 
    domainParts[0] !== 'm' && 
    !hostname.includes('localhost') && 
    !/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname);

  // 二级域名下强制沙箱限制，只允许访问校招白名单路由
  if (isSubdomain) {
    const allowedRecruitmentPaths = [
      '/index',
      '/recruitment/portal',
      '/recruitment/apply',
      '/recruitment/dashboard',
      '/login'
    ];
    const isAllowed = allowedRecruitmentPaths.some(path => to.path === path || to.path.startsWith(path + '/'));
    if (!isAllowed) {
      return next('/index');
    }
  }

  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 1.如果访问的是登录页面（无需权限），直接放行
  if (to.path === '/') return next();
  if (to.path === '/index') return next();
  if (to.path === '/login') return next();
  // 2.如果访问的是有登录权限的页面，先要获取token
  const tokenStr = localStorage.getItem('Authorization');
  // 2.1如果token为空，强制跳转到登录页面；否则，直接放行
  if (!tokenStr) {
    if (to.path === '/search' || to.path.indexOf('jobdetail/')) {
      return next();
    } else {
      return next('/index')
    }
  }
  next()
})

// main.js 或者其他入口文件
Vue.filter('formatDateMD', function (value) {
  if (value) {
    const date = new Date(value);
    const month = date.toLocaleString('default', { month: 'short' });
    // const day = date.getDate();
    const day = date.getDate();
    return `${month}${day}日`;
  }
  return value;
});

new Vue({
  render: h => h(App),
  store,
  // 配置全局事件总线
  beforeCreate() {
    Vue.prototype.$bus = this;
    // Vue.prototype.$EventBus = new Vue();
    Vue.prototype.$API = API
  },
  // 注册路由
  router,
}).$mount('#app')

